import React from "react";

const InputwithLabelandError = ({
  label = "",
  onChange,
  isError = false,
  value = {},
  type = "text",
  placeholder = "",
  isValid = false,
  isMandatory = false,
}) => {
  return (
    <div>
      <p className="text-gray-400 text-sm py-3">
        {label}
        {isMandatory ? <span className="text-red-500">*</span> : ""}
      </p>
      <input
        value={value}
        onChange={onChange}
        type={type}
        placeholder={placeholder}
        className={`w-full p-3 bg-gray-100 text-gray-500 ring-1 ${
          isError ? "ring-customError-500" : "ring-gray-300"
        } bg-gray-100 rounded-md focus:outline-none focus:ring-1 ${
          isError ? "focus:ring-customError-500" : "focus:ring-primary-500"
        } pr-10`}
      />
    </div>
  );
};

export default InputwithLabelandError;
